import BenCombinedData from "./ben-combined-data";

export default BenCombinedData;
